export const parseCookies = (cookieString: string): Record<string, string> => {
  if (!cookieString || typeof cookieString !== 'string') {
    return {};
  }

  return cookieString.split(';').reduce(
    (cookies, cookie) => {
      const [name, value] = cookie.trim().split('=');
      if (name && value) {
        cookies[name] = decodeURIComponent(value);
      }
      return cookies;
    },
    {} as Record<string, string>,
  );
};
